import { graphql, useStaticQuery } from 'gatsby';

export const useSiteMetadata = () => {
  const data = useStaticQuery(METADATA_QUERY);

  const { title, description, image } = data.data;
  const metaData = {
    title,
    description,
    image: image?.asset?.url,
  };

  return metaData;
};

const METADATA_QUERY = graphql`
  query MetaData {
    data: sanityMeta {
      title: seoTitle
      description
      image {
        asset {
          url
        }
      }
    }
  }
`;
